import React from 'react'
import request from 'superagent'
import { withRouter } from 'react-router-dom'
import { Box } from '@planningcenter/tapestry-react'

import { confirmDestroy } from '~/utils/alert.js'
import Event from '~/webhooks/components/event.jsx'
import Loading from '~/webhooks/components/loading.jsx'
import Error from '~/webhooks/components/error.jsx'
import { PageHeader } from '~/components/tapestry'
import CopyButton from '~/components/CopyButton.jsx'

const Header = ({ onActiveChange, onDelete, isSaving, body }) => {
  if (!body) {
    return null
  }
  const { name, active, authenticity_secret } = body
  return (
    <div className="d-f fd-c g-1">
      <h3>{name}</h3>

      <div className="d-f ai-c jc-sb">
        <div>
          {isSaving ? (
            <p>Saving...</p>
          ) : (
            <label className="d-f ai-c g-1">
              <input
                type="checkbox"
                className="input input--checkbox"
                checked={active}
                disabled={false}
                onChange={onActiveChange}
              />
              <p>Active</p>
            </label>
          )}
        </div>
        <div>
          <button
            onClick={onDelete}
            className="tds-btn tds-btn--delete"
            type="button"
          >
            Delete
          </button>
        </div>
      </div>

      <div className="d-f fd-c g-0.5">
        <label for="secret">Secret:</label>

        <div class="d-f ai-c g-1">
          <code className="w-100%">
            <input
              type="text"
              className="input"
              id="secret"
              value={authenticity_secret}
              readOnly
            />
          </code>

          <CopyButton copyValue={authenticity_secret} />
        </div>
      </div>
    </div>
  )
}

class Subscription extends React.Component {
  state = {
    subscription: {},
    events: [],
    isLoading: true,
    error: null,
    isActiveSaving: false,
  }

  componentDidMount() {
    const subscription = this._updateSubscription()
    const events = this._updateEvents()
    // Wait for both requests to complete before removing the loading.
    Promise.all([subscription, events]).then(() => {
      this.setState({ isLoading: false })
    })
  }

  _updateSubscription = () => {
    const { subscriptionId } = this.props.match.params
    return request
      .get(`/webhooks/v2/subscriptions/${subscriptionId}`)
      .then((res) => {
        this.setState({ subscription: res.body.data })
      })
      .catch((error) => {
        this.setState({ error: error.message })
      })
  }

  _updateEvents = () => {
    const { subscriptionId } = this.props.match.params
    return request
      .get(
        `/webhooks/v2/subscriptions/${subscriptionId}/events?order=-created_at&per_page=30`
      )
      .then((res) => {
        this.setState({ events: this.state.events.concat(res.body.data) })
      })
      .catch((error) => {
        this.setState({ error: error.message })
      })
  }

  _activeChange = (e) => {
    const active = e.target.checked
    if (this.state.subscription.attributes.active !== active) {
      this.setState({ isActiveSaving: true })
      const { subscriptionId } = this.props.match.params
      request
        .patch(`/webhooks/v2/subscriptions/${subscriptionId}`)
        .set('Content-Type', 'application/json')
        .set('X-CSRF-Token', $.rails.csrfToken())
        .send({ data: { attributes: { active: active } } })
        .then(this._updateSubscription)
        .then(() => {
          this.setState({ isActiveSaving: false })
        })
        .catch((error) => {
          this.setState({ isActiveSaving: false })
          console.error(error)
        })
    }
  }

  _deleteSubscription = () => {
    const { subscriptionId } = this.props.match.params
    confirmDestroy
      .fire({
        title: 'Delete subscription?',
        text: 'Are you sure you want to delete this subscription?',
        confirmButtonText: 'Yes, delete subscription',
      })
      .then(({ isConfirmed }) => {
        if (isConfirmed) {
          this.setState({ isLoading: true })
          request
            .delete(`/webhooks/v2/subscriptions/${subscriptionId}`)
            .set('X-CSRF-Token', $.rails.csrfToken())
            .then(() => {
              this.props.history.push('/')
            })
            .catch((error) => {
              this.setState({ isLoading: false, error: error.message })
            })
        }
      })
  }

  render() {
    const url =
      this.state.subscription.attributes &&
      this.state.subscription.attributes.url
    return (
      <Error message={this.state.error}>
        <PageHeader
          breadcrumb={
            <Box as="a" href="/webhooks">
              Back to webhooks
            </Box>
          }
        >
          <h1>{url}</h1>
        </PageHeader>

        <div className="main-body">
          <div className="main-content w-100% xw-960p mx-a">
            <Loading isLoading={this.state.isLoading}>
              <div className="pane">
                <div className="pane__header">
                  <Header
                    body={this.state.subscription.attributes}
                    onActiveChange={this._activeChange}
                    isSaving={this.state.isActiveSaving}
                    onDelete={this._deleteSubscription}
                  />
                </div>

                {this.state.events.map((event) => {
                  return (
                    <Event
                      key={event.id}
                      id={event.id}
                      subscriptionId={this.props.match.params.subscriptionId}
                      event={event.attributes}
                    />
                  )
                })}
              </div>
            </Loading>
          </div>
        </div>
      </Error>
    )
  }
}

export default withRouter(Subscription)
